module.exports = __webpack_public_path__ + "static/media/03.92e7c01d.png";